/* eslint-disable no-use-before-define */
import React from 'react'
import Button from '@material-ui/core/Button'
import Dialog from '@material-ui/core/Dialog'
import DialogActions from '@material-ui/core/DialogActions'
import DialogContent from '@material-ui/core/DialogContent'
import DialogContentText from '@material-ui/core/DialogContentText'
import DialogTitle from '@material-ui/core/DialogTitle' 

interface IConfirmationDialogProps {
  disabled: boolean
  open: boolean,
  handleYes: () => void,
  handleNo: () => void
}

const ConfirmationDialog: React.FC<IConfirmationDialogProps> = ({disabled, open, handleYes, handleNo}) => {    
  return (
    <div> 
      <Dialog
        open={open}
        onClose={handleNo} 
        aria-labelledby="draggable-dialog-title"
      >
        <DialogTitle style={{ cursor: 'move' }} id="draggable-dialog-title">
          Confirmation
        </DialogTitle>
        <DialogContent>
          <DialogContentText>
            Are you sure want to send this push notification?
          </DialogContentText>
        </DialogContent>
        <DialogActions>
          <Button autoFocus onClick={handleNo} color="primary" disabled={disabled}>
            No
          </Button>
          <Button onClick={handleYes} variant="contained" color="primary" autoFocus disabled={disabled}>
            Yes
          </Button>
        </DialogActions>
      </Dialog>
    </div>
  )
}

export default ConfirmationDialog